const environment = process.env.REACT_APP_ENVIROMENT;
export const prod =
  // eslint-disable-next-line no-nested-ternary
  environment === 'production'
    ? 'https://athletes.cpandr.co.uk'
    : environment === 'staging'
    ? 'https://cpnr-the-clubhouse-staging-f870e0360c93.herokuapp.com'
    : 'http://localhost:5002';
